import { AVIS_GARANTIS_ID, AVIS_GARANTIS_URL } from './utils/Variables';

export function initAvisGarantis() {
  initAvisGarantisCockade();
}

function initAvisGarantisCockade() {
  if (document.getElementsByClassName('js--avis-garantis-cockade').length > 0) {
    ['mousemove', 'touchmove'].forEach(event =>
      window.addEventListener(
        event,
        function () {
          fetch(
            'https://www.societe-des-avis-garantis.fr/wp-content/plugins/ag-core/widgets/cache/jsv2/' +
              AVIS_GARANTIS_ID +
              '.html'
          )
            .then(response => {
              return response.text();
            })
            .then(html => {
              const node = document.createElement('div');
              node.style.display = 'none';
              node.innerHTML = html;

              window.openCertificate = function () {
                var win = window.open(AVIS_GARANTIS_URL, '_blank');
                if (win) {
                  win.focus();
                }
              };

              document.body.appendChild(node);

              let cockade = document.getElementById('sag_b_cocarde');
              if (!cockade) {
                cockade = document.getElementById('sag_b_classic');
              }

              if (cockade) {
                const cockadeClone = cockade.cloneNode(true);

                Array.prototype.forEach.call(
                  document.getElementsByClassName('js--avis-garantis-cockade'),
                  function (el) {
                    el.innerHTML = '';
                    el.appendChild(cockadeClone);
                  }
                );
              }
            });
        },
        { once: true }
      )
    );
  }
}
